import { colors } from 'us-react-components/dist/constants/Styles';

export const STATUS_BORDER_COLOR: Record<string, string> = {
  ACTIVE: colors.success[500],
  REJECTED: colors.error[500],
  SUPERSEDED: colors.gray[400],
};

export const STATUS_CHIP_COLOR: Record<string, 'success' | 'error' | 'default'> = {
  ACTIVE: 'success',
  REJECTED: 'error',
  SUPERSEDED: 'default',
};

export const DEFAULT_BORDER_COLOR = colors.gray[300];
